import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge, Subject, Subscription, switchMap, tap, timer } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class IdleTimerService {
private idle$ = new Subject<void>();
  private activityEvents$ = merge(
    fromEvent(window, 'mousemove'),
    fromEvent(window, 'keydown'),
    fromEvent(window, 'mousedown'),
    fromEvent(window, 'touchstart')
  );
  private timerSubscription: Subscription | undefined;
  constructor(private ngZone: NgZone) { }
  startIdleWatch(timeoutMinutes: number) {
    this.ngZone.runOutsideAngular(() => {
      if (this.timerSubscription) this.timerSubscription.unsubscribe();
      this.timerSubscription = this.activityEvents$.pipe(
        switchMap(() => timer(timeoutMinutes * 60 * 1000))
      ).subscribe(() => {
        this.ngZone.run(() => this.idle$.next());
      });
    });
  }
  onIdle() {
    return this.idle$.asObservable();
  }
  stop() {
    if (this.timerSubscription) this.timerSubscription.unsubscribe();
  } 
}
